import {
	Navigate,
	RouterProvider,
	createBrowserRouter,
} from 'react-router-dom';
import store from '../store/store';
import { base64UrlToString } from '../utils/utils';
import PageIntro from '../pages/intro/PageIntro';
import PageStart from '../pages/start/PageStart';
import PageQuestions from '../pages/questions/PageQuestions';
import PageVisaQuestions from '../pages/questions/PageVisaQuestions';
import PageSubResult from '../pages/sub-result/PageSubResult';
import PageResult from '../pages/result/PageResult';
import PageVisaResult from '../pages/result/PageVisaResult';
import PageShareVisaResult from '../pages/result/PageShareVisaResult';
import { getVisaResult } from '../store/visaProgramSlice';

let routes = createBrowserRouter([
	{
		// Shows the introduction page, optionally at a specific position.
		path: '/intro/:position?',
		Component: PageIntro,
	},
	{
		// Displays the start page to begin the migration process.
		path: '/start',
		Component: PageStart,
	},
	{
		// Presents the main questionnaire to the user.
		path: '/questions',
		Component: PageQuestions,
	},
	{
		// Presents the main visa questionnaire to the user.
		path: '/visaQuestions',
		Component: PageVisaQuestions,
	},
	{
		// Shows a sub-result or intermediate result page.
		path: '/subResult',
		Component: () => <PageSubResult key={Math.floor(Math.random() * 1000000)} />,
	},
	{
		// Displays the final migration result to the user.
		path: '/result',
		Component: () => <PageResult key={Math.floor(Math.random() * 1000000)} />,
	},
	{
		// Displays the final visa result to the user.
		path: '/result/final',
		Component: () => <PageVisaResult key={Math.floor(Math.random() * 1000000)} />,
	},
	// {
	// 	// Loads and displays a shared result based on the share key.
	// 	path: '/share/:shareKey',
	// 	Component: PageShareResult,
	// 	loader: async ({ params }) => {
	// 		await store.dispatch(fetchResults({ sessionId: base64UrlToString(params.shareKey || '') }));
	// 		return null;
	// 	},
	// },
	{
		// Loads and displays a shared result based on the share key.
		path: '/share/:shareKey',
		Component: PageShareVisaResult,
		loader: async ({ params }) => {
			await store.dispatch(getVisaResult({ sessionId: base64UrlToString(params.shareKey || '') }));
			return null;
		},
	},
	{
		// Redirects any unknown route to the introduction page.
		path: '*',
		Component: () => <Navigate to="/intro" replace />,
	},
]);

const Router = () => {
	return <RouterProvider router={routes} />;
};

export default Router;
